import { Link } from "react-router-dom";
import type { Role } from "../api";
import { ROLE_LABELS } from "../api";
import { EmptyState } from "../components";
import styles from "./Forbidden.module.css";

/** Écran « accès refusé » : lisible, et avec la sortie. */
export function Forbidden({ role, home }: { role: Role; home: string }) {
  return (
    <div className={styles.page} role="alert">
      <h1 className="lde-visually-hidden">Accès refusé</h1>
      <EmptyState
        icon="🔒"
        title="Accès refusé"
        description={`Votre rôle (${ROLE_LABELS[role]}) ne permet pas d'ouvrir cette page.`}
        action={
          <Link className={styles.lien} to={home}>
            Retour à l'accueil
          </Link>
        }
      />
    </div>
  );
}
